import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from '@/components/Login.vue'
import MainLayout from '@/components/MainLayout.vue'
import SiteDetail from '@/components/SiteDetail.vue'
import RechargeWizard from "@/components/RechargeWizard.vue";
import PrivacyPage from "@/components/PrivacyPage.vue";
import TermsPage from "@/components/TermsPage.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/suno'
    },
    {
        path: '/login',
        name: 'Login',
        component: LoginPage
    }
    ,
    {
        path: '/recharge',
        name: 'RechargePage',
        component: RechargeWizard
    }
    ,
    {
        path: '/privacy',
        name: 'PrivacyPage',
        component: PrivacyPage
    }
    ,
    {
        path: '/terms',
        name: 'TermsPage',
        component: TermsPage
    },
    {
        path: '/site-detail',
        name: 'SiteDetail',
        component: SiteDetail
    },
    {
        path: '/main',
        name: 'Main',
        component: MainLayout,
        children: [
            {
                path: '/home',
                name: 'Home',
                component: () => import('@/components/Home.vue')
            },
            {
                path: '/orders',
                name: 'Orders',
                component: () => import('@/components/Orders.vue')
            },
            {
                path: '/hot-sites',
                name: 'HotSites',
                component: () => import('@/components/HotSites.vue')
            },
            {
                path: '/suno',
                name: 'SunoHome',
                component: () => import('@/components/SunoHome.vue')
            }

        ]
    }
]
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 处理冗余导航错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
    })
}

export default router
